export const TOGGLE_LOADING = "TOGGLE_LOADING";
